import React from 'react';

export const StreakDeath = ({ showStreakDeath, setShowStreakDeath }) => {
  if (!showStreakDeath) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-black flex items-center justify-center pointer-events-auto"
      onClick={() => setShowStreakDeath(false)}>
      <div className="animate-levelup-shake w-full max-w-4xl px-4">
        <div className="bg-gradient-to-r from-red-600 to-black border-8 border-red-500 p-12 shadow-2xl"
          style={{ filter: 'drop-shadow(0 0 60px rgba(239, 68, 68, 0.8))' }}>
          <div className="text-center">
            <div className="text-6xl sm:text-8xl md:text-9xl font-black text-red-500 mb-6 animate-pulse uppercase tracking-tighter">
              STREAK DEAD
            </div>
            <div className="text-3xl sm:text-5xl md:text-6xl font-black text-white uppercase mb-4">
              YOU BITCHED OUT
            </div>
            <div className="text-xl sm:text-3xl md:text-4xl font-black text-orange-400 uppercase mb-8">
              RECOVERY MODE: NEXT SEND = 2× POINTS
            </div>
            <div className="text-sm sm:text-base font-black text-gray-400 uppercase animate-pulse">
              TAP ANYWHERE TO CONTINUE
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
